<template>
	<v-chip color="#f2f2f2" class="ml-1" small @click="showDetails = true">
		{{drug.name}}<span v-if="drug.info" class="ml-1 drug-info"> - {{drug.info}}</span>
		<v-dialog v-model="showDetails" max-width="360">
			<v-card>
				<v-card-title class="title primary--text mb-2 secondary" v-translate>Drug Info</v-card-title>

				<v-card-text>
					<p>
						<strong v-translate>Name:</strong>
						{{drug.name}}
					</p>
					<p>
						<strong v-translate>Generic Name:</strong>
						{{drug.generic_name}}
					</p>
					<p>
						<strong v-translate>Presentation:</strong>
						{{drug.farm_formula}}
					</p>
					<p>
						<strong v-translate>Dosage:</strong>
						{{drug.dosage}}
					</p>
					<p>
						<strong v-translate>Generic:</strong>
						<span class="ml-1" v-if="drug.is_generic" v-translate>Yes</span>
						<span class="ml-1" v-else v-translate>No</span>
					</p>
					<p>
						<strong v-translate>Owner:</strong>
						{{drug.owner}}
					</p>
					<template v-if="drug.info">
						<v-divider></v-divider>
						<p class="mt-2">{{drug.info}}</p>
					</template>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" text @click="showDetails = false">
						<translate>Close</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-chip>
</template>

<script>
export default {
	name: "DrugItemHistory",
	props: ["drug"],
	data: () => ({
    showDetails: false
  })
};
</script>

<style scoped>
	.drug-info {
		max-width: 100px;
		text-overflow: ellipsis;
		overflow: hidden;
	}
</style>